import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetailTableRowComponent } from './detail-table-row/detail-table-row.component';
import { PropertyDetails } from 'src/app/services/portal-api.service';
import { switchMap, tap } from 'rxjs';


@Component({
  selector: 'app-detail-section',
  standalone: true,
  imports: [CommonModule, DetailTableRowComponent, TranslocoDirective, TranslocoPipe],
  templateUrl: './detail-section.component.html',
  styleUrl: './detail-section.component.css'
})
export class DetailSectionComponent implements OnInit {
  @Input() model = new PropertyDetails();

  public parkingTypeString: string | undefined;
  public storageTypeString: string | undefined;

  protected isCollapsed: boolean = true;

  constructor(private _translocoService: TranslocoService) {}

  ngOnInit(): void {
    this._translocoService.selectTranslateObject('shared.enum.parkingType', undefined).pipe(
      tap((translations) => {
        this.parkingTypeString = this.model.parkingType?.map((x) => translations[x]).join(', ');
      })
    ).subscribe();

    this._translocoService.selectTranslateObject('shared.enum.storageType').pipe(
      tap((translations) => {
        this.storageTypeString = this.model.storageType?.map((x) => translations[x]).join(', ');
      })
    ).subscribe();
  }

  toggleCollapse(event: MouseEvent) {
    this.isCollapsed = !this.isCollapsed;
  }
}
